import { ColDef, ICellRendererParams } from 'ag-grid-community'
import styles from './ProjectForecastReports.module.css'
import { ProjectForecastReportRow } from '../../../interfaces/systemSettings/ProjectForecastReport'
import LinkActionButton from '../../Buttons/LinkActionButton'

export const getProjectForecastReportColumnDefs = (
  getProjectForecastUrl: (projectId: string) => string
): ColDef<ProjectForecastReportRow>[] => [
  {
    field: 'checkbox',
    headerName: '',
    checkboxSelection: true,
    headerCheckboxSelection: true,
    width: 50,
    maxWidth: 50,
    resizable: false,
    sortable: false,
    filter: false,
    suppressMenu: true,
    pinned: 'left',
  },
  {
    field: 'projectName',
    headerName: 'Projektnamn',
    minWidth: 220,
  },
  {
    field: 'projectClassName',
    headerName: 'Projektklass',
    minWidth: 170,
  },
  {
    field: 'year',
    headerName: 'År',
    maxWidth: 100,
  },
  {
    field: 'reportPeriod',
    headerName: 'Period',
    maxWidth: 110,
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 100,
  },
  {
    field: 'projectId',
    headerName: 'ProjektId',
    minWidth: 80,
  },
  {
    field: 'id',
    headerName: 'RapportId',
    minWidth: 180,
  },
  {
    colId: 'openProjectForecast',
    headerName: 'Prognosuppföljning',
    minWidth: 180,
    maxWidth: 200,
    sortable: false,
    filter: false,
    suppressMenu: true,
    cellClass: styles.projectForecastActionCell,
    getQuickFilterText: () => '',
    cellRenderer: (params: ICellRendererParams<ProjectForecastReportRow>) => (
      <LinkActionButton
        text="Prognosuppföljning"
        url={getProjectForecastUrl(params.data?.projectId ?? '')}
        className={styles.projectForecastActionButton}
      />
    ),
  },
]
